import styled, {css} from 'styled-components'
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ChatIcon from '@material-ui/icons/Chat';
import YouTubeIcon from '@material-ui/icons/YouTube';
import {FaFacebookF} from 'react-icons/fa'
import ListAltIcon from '@material-ui/icons/ListAlt';

export const Sticky = styled.div`
    position: sticky;
    top: calc(50% - 300px / 2);
    align-self: flex-start;

    @media screen and (max-width: 1023px) {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        top: auto;
        background: #fff;
        z-index: 1;
    }
`

export const StickyMenuText = styled.p`
    color: #222;
    font-size: 14px;
    position: absolute;
    top: 36px;
    left: -1px;
    text-align: center;
    width: 34px;
`

const iconStyles = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    color: #222;
    font-size: 18px !important;
`

export const LikeIcon = styled(ThumbUpIcon)`
    ${iconStyles};
`

export const CommentIcon = styled(ChatIcon)`
    ${iconStyles};
`

export const YoutubeIcon = styled(YouTubeIcon)`
    ${iconStyles};
    font-size: 22px !important;
`

export const FacebookIcon =  styled(FaFacebookF)`
    ${iconStyles};
`
export const SaveIcon = styled(ListAltIcon)`
    ${iconStyles};
`

export const ZaloIcon = styled.span`
    ${iconStyles};
    font-size: 12px !important;
    font-weight: 500;
    color: #000;
`

export const StickyMenuLink = styled.a`
    width: 34px;
    height: 34px;
    border-radius: 100%;
    border: 1px solid #222;
    opacity: .5;
    display: block;
    position: relative;
    cursor: pointer;
    margin-bottom: 12px;
    text-decoration: none;
    color: #222;

    &.mb-24 {
        margin-bottom: 24px;
    }

    @media screen and (min-width: 1023px) {
        &:hover {
            border: 1px solid #e32;
            opacity: 1;

            .sticky-menu-icon,${StickyMenuText} {
                color: #e32;
            }
        }
    }

    &.active {
        .sticky-menu-icon,${StickyMenuText} {
            color: #e32;
        }
        border: 1px solid #e32;
        opacity: 1;
    }

    @media screen and (max-width: 1023px) {
        display: flex;
        align-items: center;
        border-radius: unset;
        border: none !important;
        width: 40px;
        height: 40px;
        margin: 0 !important;

        ${StickyMenuText} {
            top: 50%;
            transform: translateY(-50%);
            left: calc(100% - 20px);
        }
    }
`

export const Menu = styled.ul`
    list-style: none;

    @media screen and (max-width: 1023px) {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding: 0 30px;
        align-items: center;
    }

    @media screen and (max-width: 767px) {
        padding: 0 15px;
    }
`

export const StickyMenuItem = styled.li`
    margin-bottom: 10px;

    @media screen and (max-width: 1023px) {
        margin: 0;
    }
`